import { render, staticRenderFns } from "./DebugFront.vue?vue&type=template&id=672c491e&scoped=true&"
import script from "./DebugFront.vue?vue&type=script&lang=js&"
export * from "./DebugFront.vue?vue&type=script&lang=js&"
import style0 from "./DebugFront.vue?vue&type=style&index=0&id=672c491e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "672c491e",
  null
  
)

export default component.exports